import React from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import { ENTRYPOINT_TYPE } from './constant';

const EntrypointCv = dynamic(() => import('./Entrypoint/EntrypointCv'), {
  loading: () => <div />,
  ssr: false,
});

const EntrypointNonCv = dynamic(() => import('./Entrypoint/EntrypointNonCv'), {
  loading: () => <div />,
  ssr: false,
});

const JsDatabaseEntryPoint = (props) => {
  const { type, onClickCreateCv, data, auth, onClickToggle, onClickUpdate, isFoundCv } = props;
  switch (type) {
    case ENTRYPOINT_TYPE.CV:
      return (
        <EntrypointCv
          info={data}
          auth={auth}
          onClickToggle={onClickToggle}
          onClickUpdate={onClickUpdate}
          isFoundCv={isFoundCv}
        />
      );
    case ENTRYPOINT_TYPE.NON_CV:
      return <EntrypointNonCv onClick={onClickCreateCv} />;
    default:
      return null;
  }
};

JsDatabaseEntryPoint.propTypes = {
  type: PropTypes.string.isRequired,
  onClickCreateCv: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  onClickToggle: PropTypes.func.isRequired,
  onClickUpdate: PropTypes.func.isRequired,
  isFoundCv: PropTypes.bool.isRequired,
};

export default JsDatabaseEntryPoint;
